import { assign, get } from "lodash";
import { OnlineDSAList } from "../views/OnlineDsa/OnlineDsa";

export const endPoints = {
	leads: {
		fetchleads: "/leads/get-leads",
		upsertLead: "/leads/auth-upsert-leads",
		getFollowUpHistory: "/leads/get-followup-history",
	},
	events: {
		getEventType: "/manageTypes/get-event-type",
		upsertEventType: "/manageTypes/upsert-event-type",
	},
	partners: {
		getPartnerMaster: "/partner/get-partner-master",
		upsertPartnerMaster: "/partner/upsert-partner-master",
		getPartnerMembership: "/partner/get-partner-membership",
		upsertPartnerMembership: "/partner/upsert-partner-membership",
		getBulkActivation: "/partner/get-bulk-activation",
		upsertBulkActivation: "/partner/upload-bulk-activation",
		getPartnerPackageMaster: "/partner/get-partner-package-master",
		upsertPartnerPackageMaster: "/partner/upsert-partner-package-master",
		getComplaintLog: "/partner/get-complaint-log",
		getRsaComplaintLog: "/complaint/get-rsa-complaint-log",
		getComplaintReport: "/partner/get-complaint-report",
		activateMemberships: "/partner/activate-bulk-partner-membership",
		downloadPartnerMembership: "/partner/download-membership-card",

	},
	opportunity: {
		createOpportunity: "/leads/create-opportunity",
	},
	insurer: {
		createInsurer: "/insurance/create-insurer-code",
	},
	csioCompany: {
		upsertCSIOCompany: "/insurance/create-csio-company-record",
	},
	subInusrer: {
		upsertSubInsurer: "/insurance/create-insurer-sub",
	},
	policyComission: {
		upsertPolicyComission: "/insurance/create-policy-commission",
	},
	insurerContacts: {
		upsertInsurerContacts: "/insurance/create-insurer-contacts",
	},
	underWriters: {
		upsertUnderwriters: "/insurance/create-underwriters",
	},
	brokerCodes: {
		createBrokerCode: "/insurance/create-broker-code",
	},
	brokerContacts: {
		createBorkerContact: "/insurance/create-broker-contracts",
	},
	branchOffice: {
		createBranchOffice: "/insurance/create-branch-office",
	},
	interestedParty: {
		createIntrestedParty: "/insurance/create-interested-party",
	},
	additionalIntrest: {
		createAdditionalIntrest: "/insurance/create-additional-interest",
	},
	appForms: {
		editAppForms: "/other/edit-apps-and-forms",
	},
	support: {
		upsertSupport: "/other/create-support-ticket",
	},
	legalPlus: {
		upsertLegal: "/other/upsert-legal-plus",
	},
	OnlineDSAList: {
		fetchOnlineDsaList: "/OnlineDsaLimit/get-online-dsa-limit",
		upsertOnlineDsaLimit: "/OnlineDsaLimit/upsert-online-dsa-limit",
	},
	LeadsfromWebsite: {
		fetchLeadsfromWebsite: "dataManagement/get-enquiry-request",
		upsertLeadsfromWebsite: "dataManagement/upsert-enquiry-request",
	},
	crossroadsLeads: {
		upsertCrossroadsLeads: "/crossroadsLead/upsert-crossroads-lead",
		getCrossroadsLeadsList: "/crossroadsLead/get-crossroads-lead",
		getFollowUpHistory: "/crossroadsLead/get-crossroads-leads-followup-history",
		getCampaignRuleTemplate: "/crossroadsLead/get-campaign-rule-template",
		getCrossroadsAnalytics: "/crossroadsLead/lead-followups-analytics-crossroads",
		getCrossroadsStatusLeads: "/crossroadsLead/get-status-crossroads-lead",
		getCampaignReports: "/crossroadsLead/get-crossroads-lead-reports",
		getMemberships: "/crossroadsLead/get-memberships-from-crossroads",
		getInvoices: "/crossroadsLead/get-invoice-from-crossroads",
		getVehicleDetails: "/crossroadsLead/get-customer-vehicle-details",
		getCustomerConnectionDetails: "/crossroadsLead/get-customer-connection-details-from-crossroads",
		getCrossroadsComplaintLog: "/crossroadsLead/get-crossroads-complaint-log",
		getLeadsDateWiseCount: "/crossroadsLead/get-leads-date-wise-count",
		getAssigneeAndManagerBasisLeadsCount: "/crossroadsLead/get-assignee-and-manager-basis-leads-count",
	},
	calling: {
		upsertCallCampaign: "/calling/upsert-call-campaign",
		getCallCampaign: "/calling/get-call-campaign",
		upsertCallCampaignData: "/calling/upsert-call-campaign-data",
		getCallCampaignData: "/calling/get-call-campaign-data",
		assignCallCampaignDataToLead: "/calling/assign-call-campaign-data-to-lead",
		assignCallCampaignDataToAgent: "/calling/assign-call-campaign-data-to-agent",
		insertBulkCallCampaign: "/crossroadsLead/upload-crossroads-lead-data",
	},
	upsell: {
		upsellTemplate: "/"
	},
	campaign: {
		upsertCampaign: "/crossroadsLead/upsert-campaign",
		getCampaign: "/crossroadsLead/get-campaign",
	},
	apikey: {
		upsertApiKey: "/crossroadsLead/upsert-apikey",
		getApiKey: "/crossroadsLead/get-apikey",
	},
	packages: {
		getRsaPackages: "/packages/get-rsa-package",
		upsertRsaPackages: "/packages/upsert-rsa-package",
	},
	promocode: {
		getPromocode: "/promocode/get-rsa-promocode",
		upsertPromocode: "/promocode/upsert-rsa-promocode",
	},
	disposition: {
		getDisposition: "/crossroadsLead/get-disposition",
		upsertDisposition: "/crossroadsLead/upsert-disposition",
	},
	deals: {
		getB2bDeal: "/leads/get-b2b-deal",
		upsertB2bDeal: "/leads/upsert-b2b-deal",
	},
	lawyered: {
		getLawyeredChallan: "/lawyered/get-lawyered-challan",
	},
};
